import LoadingCircle from '@/assets/icons/LoadingCircle.svg';
import * as Styled from './LoadingSpinner.styled';

export const LoadingSpinner = () => (
  <Styled.Spinner aria-label="Loading…" isIndeterminate value={60}>
    <LoadingCircle />
  </Styled.Spinner>
);
